import { CREATESTEP1_OK, CREATESTEP1_ERR } from "./createStep1.action";

const InitState = {
  error: null,
  content: null,
};

export default function CreatStep1Reducer(state = InitState, action) {
  switch (action.type) {
    case CREATESTEP1_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case CREATESTEP1_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
